import * as ActionTypes from '../constants/ActionTypes';
import { SAVE_LEVEL } from '../constants/Level';
import { isEmpty } from 'lodash';

function setGlobalFontColor(layer, color) {
    return {
        type: ActionTypes.THEME_GLOBAL_SET_THEME_FONT_COLOR,
        layer: layer,
        color: color
    };
}

function setGlobalFontSize(layer, size) {
    return {
        type: ActionTypes.THEME_GLOBAL_SET_THEME_FONT_SIZE,
        layer: layer,
        size: size
    };
}

function setGlobalFontWeight(layer, weight) {
    return {
        type: ActionTypes.THEME_GLOBAL_SET_THEME_FONT_WEIGHT,
        layer: layer,
        weight: weight
    };
}

function setGlobalFontStyle(layer, style) {
    return {
        type: ActionTypes.THEME_GLOBAL_SET_THEME_FONT_STYLE,
        layer: layer,
        style: style
    };
}

function setTextDecoration(layer, decoration) {
    return { type: ActionTypes.THEME_GLOBAL_SET_THEME_TEXT_DECORATION, layer: layer, decoration: decoration };
}

function setLineHeight(layer, lineHeight) {
    return { type: ActionTypes.THEME_GLOBAL_SET_THEME_LINE_HEIGHT, layer: layer, lineHeight: lineHeight };
}

function setTextAlignment(layer, alignment) {
    return { type: ActionTypes.THEME_GLOBAL_SET_THEME_TEXT_ALIGN, layer: layer, align: alignment };
}

function setBorderStyle(layer, style) {
    return { type: ActionTypes.THEME_GLOBAL_SET_THEME_BORDER_STYLE, layer: layer, style: style };
}

function setBorderWidth(layer, width) {
    return { type: ActionTypes.THEME_GLOBAL_SET_THEME_BORDER_WIDTH, layer: layer, width: width };
}

function setFontColor(layer, color) {
    return {
        type: ActionTypes.THEME_GLOBAL_SET_THEME_FONT_COLOR,
        layer: layer,
        color: color
    };
}

const getPropertyTitle = () => (dispatch, getState) => {
    const state = getState();
    const selected = state.app.selected;
    if (selected.level === SAVE_LEVEL.HOTEL && !isEmpty(selected.selectedHotel)) {
        return `${selected.chain.Id} | ${selected.selectedHotel.name}`;
    }

    return `${selected.chain.Id}`;
};

const getThemeTitle = () => (dispatch, getState) => {
    const state = getState();
    const defaultTheme = state.app.referenceState.initialData.theme.themes.find(t => t.status === 'default');
    const selected = state.app.selected;
    const themeCode = selected.code ? selected.code : selected.contentCode;

    return defaultTheme ? `${themeCode}` : '';
};

const getConfigTitle = () => (dispatch, getState) => {
    const state = getState();
    const defaultConfig = state.app.referenceState.initialData.theme.config.find(config => config.status === 'default');
    const selected = state.app.selected;
    const configCode = state.app.data.configuration.configuration.configCode
        ? state.app.data.configuration.configuration.configCode
        : selected.contentCode;

    return defaultConfig ? `${configCode}` : '';
};

export {
    setGlobalFontColor,
    setGlobalFontSize,
    setGlobalFontWeight,
    setGlobalFontStyle,
    setTextDecoration,
    setLineHeight,
    setTextAlignment,
    setBorderStyle,
    setBorderWidth,
    setFontColor,
    getPropertyTitle,
    getThemeTitle,
    getConfigTitle
};



// WEBPACK FOOTER //
// ./src/actions/global.js